import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blured-document',
  templateUrl: './blured-document.component.html',
  styleUrls: ['./blured-document.component.scss'],
  standalone: false
})
export class BluredDocumentComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
